export default __webpack_public_path__ + "static/postgres-logo-856aab96a0fa6212036a92b4ff0640dc.png";